var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11V17M7 14H13",
    stroke: "#0043A1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6H14C15.6569 6 17 7.34315 17 9V19C17 20.6569 15.6569 22 14 22H6C4.34315 22 3 20.6569 3 19V9C3 7.34315 4.34315 6 6 6ZM6 8C5.44772 8 5 8.44772 5 9V19C5 19.5523 5.44772 20 6 20H14C14.5523 20 15 19.5523 15 19V9C15 8.44772 14.5523 8 14 8H6Z",
    fill: "#0043A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 2H10C8.34315 2 7 3.34314 7 5V6H9V5C9 4.44772 9.44772 4 10 4H18C18.5523 4 19 4.44772 19 5V15C19 15.5523 18.5523 16 18 16H17V18H18C19.6569 18 21 16.6569 21 15V5C21 3.34315 19.6569 2 18 2Z",
    fill: "#0043A1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClone);
export default __webpack_public_path__ + "static/media/clone.cbbaadcd448f340a44ee76013ab165af.svg";
export { ForwardRef as ReactComponent };